import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Slider from 'rc-slider';
import {FormControl} from 'react-bootstrap';
import {RADIX_DECIMAL} from 'util/constants';
import {selectOnFocus} from 'util/utils';

import 'style/components/ui/form/dates/time/time-selector-detail.scss';

const
    MAX_HOURS = 23,
    MAX_MINUTES = 59,
    STEP = 1,
    MIN_TIME = 0;

const _renderControl = (label, value, onChange, slider, disabled) => (
    <div className="time-selector-detail-control">
        <label>{label}</label>
        <FormControl disabled={disabled} value={value} onInput={onChange} onFocus={selectOnFocus} />
        <Slider disabled={disabled} value={value} min={slider.min} max={slider.max} step={slider.step} onChange={onChange}/>
    </div>
);

/** Component to select a month using a dropdown calendar component */
class TimeSelectorDetail extends Component {

    static propTypes = {
        value:        PropTypes.number, // The timestamp of the date to show
        onChange:     PropTypes.func, // Listener for when the date is changed
        onSubmit:     PropTypes.func, // Listener for when the component is submitted
        labelHours:   PropTypes.string, // The text for the hours label
        labelMinutes: PropTypes.string, // The text for the minutes label
        disabled:     PropTypes.bool // True when should be disabled
    };

    static defaultProps = {
        disabled:     false,
        labelHours:   'Hours',
        labelMinutes: 'Minutes'
    };

    state = {
        time: {
            hours:   MIN_TIME,
            minutes: MIN_TIME
        }
    };

    /**
     * Init the state and set this to handlers
     */
    componentWillMount() {
        this.handleHourChange = this.handleHourChange.bind(this);
        this.handleMinuteChange = this.handleMinuteChange.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        const {value} = this.props;

        if (value !== nextProps.value) {
            if (nextProps.value) {
                const date = new Date(nextProps.value);

                this.setState({
                    time: {
                        hours:   date.getHours(),
                        minutes: date.getMinutes()
                    }
                });
            } else {
                this.setState({
                    time: {
                        hours:   MIN_TIME,
                        minutes: MIN_TIME
                    }
                });
            }
        }
    }

    /**
     * Change the date when a year is clicked also goes to month panel
     * @param e event for hour change.
     */
    handleHourChange(e) {
        const
            eventHours = e.currentTarget && e.currentTarget.value,
            value = eventHours || e,
            {onChange} = this.props,
            {time} = this.state,
            newTime = {...time};

        newTime.hours = isNaN(value) ? MIN_TIME : parseInt(value, RADIX_DECIMAL);
        newTime.hours = newTime.hours > MAX_HOURS ? MAX_HOURS : newTime.hours;

        if (onChange) {
            onChange(newTime);
        } else {
            this.setState({
                time: newTime
            });
        }
    }

    handleMinuteChange(e) {
        const
            eventMinutes = e.currentTarget && e.currentTarget.value,
            value = eventMinutes || e,
            {time} = this.state,
            {onChange} = this.props,
            newTime = {...time};

        newTime.minutes = isNaN(value) ? MIN_TIME : parseInt(value, RADIX_DECIMAL);
        newTime.minutes = newTime.minutes > MAX_MINUTES ? MAX_MINUTES : newTime.minutes;

        if (onChange) {
            onChange(newTime);
        } else {
            this.setState({
                time: newTime
            });
        }


        /*
        const {time} = this.state;
        const {onChange} = this.props;
        const eventMinutes = e.currentTarget && e.currentTarget.value;

        time.minutes = eventMinutes || e;
        time.minutes = isNaN(time.minutes) ? MIN_TIME : parseInt(time.minutes, 10);
        time.minutes = time.minutes > MAX_MINUTES ? MAX_MINUTES : time.minutes;

        this.setState({
            time
        }, () => {
            onChange(this.state.time);
        });
        */
    }

    clear() {
        this.setState({time: {
            hours:   MIN_TIME,
            minutes: MIN_TIME
        }});
    }

    render() {
        const {labelHours, labelMinutes, disabled} = this.props;
        const {time} = this.state;

        const hours = time.hours || MIN_TIME;
        const minutes = time.minutes || MIN_TIME;

        return (
            <div className="time-selector-detail">
                {_renderControl(labelHours, hours, this.handleHourChange, {min: MIN_TIME, max: MAX_HOURS, step: STEP}, disabled)}
                {_renderControl(labelMinutes, minutes, this.handleMinuteChange, {min: MIN_TIME, max: MAX_MINUTES, step: STEP}, disabled)}
            </div>
        );
    }
}

export default TimeSelectorDetail;



// WEBPACK FOOTER //
// ./src/components/ui/form/dates/time/TimeSelectorDetail.js